<template>
    <v-container fluid class="d-flex flex-column align-stretch parent-container">
        <div class="search">
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            label="Search"
                            v-model="search"        
                            dense
                            clearable filled solo hide-details
                            prepend-inner-icon="mdi-text-search"
                            width="50px" 
                            class="elevation-8 pt-0">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div class="d-flex tree-view-container flex-grow-1">
           <template v-if="taxonomies">
                <v-treeview
                    ref="treeView"
                    hoverable
                    transition
                    :filter="filterTaxonomies"
                    :items="taxonomies.pre"
                    item-children="concepts"
                    item-text="label"
                    :search="searchText"
                    :open.sync="openNodes">
                    <template #prepend="{item}">
                        <uv-button small :key="item.id" @click.stop="openDialog(item)" color="success" v-if="!conceptIsAbstract(item) && !showEditAndDeleteButtons(item)" :disabled="isReadOnly" icon title="Apply Tag">
                            <v-icon>mdi-plus-box</v-icon>
                        </uv-button>
                        <uv-button small @click.stop="openDialog(item, true)" color="success" v-if="showContinueButton(item) && !showEditAndDeleteButtons(item)" :disabled="isReadOnly" icon title="Continue Tag">
                            <v-icon>mdi-plus-box-multiple</v-icon>
                        </uv-button>
                        <uv-button small :key="item.id" @click.stop="handleClickOnRemoveTagBtn(item)" color="error" v-if="showEditAndDeleteButtons(item)" :disabled="isReadOnly" icon title="Delete Tag">
                            <v-icon>mdi-minus-box</v-icon>
                        </uv-button>
                        <uv-button small @click.stop="openDialog(item)" color="warning" v-if="showEditAndDeleteButtons(item)" :disabled="isReadOnly" icon title="Edit Aspects">
                            <v-icon>mdi-pencil-box</v-icon>
                        </uv-button>
                        <!-- daca sunt putine butoane, le afisam pe toate -->
                        <template v-if="getXbrlIdsByConceptId(item.id)?.length <= 3">
                            <uv-button v-for="goToButtonId of getXbrlIdsByConceptId(item.id)" 
                            :color="currentSelectedContinuation(goToButtonId) && showEditAndDeleteButtons(item) ? 'warning' : 'blue' " 
                            :key="`item-goto-${goToButtonId}`" 
                            small icon 
                            :title="!isContinuationItem(goToButtonId) ? 'Go to tag':'Go to tag continuation'"
                                @click="goToTag(goToButtonId)">
                                    <v-icon v-if=!isContinuationItem(goToButtonId)>mdi-arrow-bottom-left-thick</v-icon>
                                    <v-icon v-else>mdi-arrow-bottom-left-bold-outline</v-icon>
                            </uv-button>
                        </template>
                        <!-- daca sunt mai multe, afisam primele 3 si pe restul intr-un meniu -->
                        <template v-else>
                            <uv-button v-for="goToButtonId of getXbrlIdsByConceptId(item.id).slice(0,3)" 
                            :color="currentSelectedContinuation(goToButtonId) && showEditAndDeleteButtons(item) ? 'warning' : 'blue' " 
                            :key="`item-goto-${goToButtonId}`" 
                            small icon 
                            :title="!isContinuationItem(goToButtonId) ? 'Go to tag':'Go to tag continuation'"
                            @click="goToTag(goToButtonId)">  
                                <v-icon v-if="!isContinuationItem(goToButtonId)">mdi-arrow-bottom-left-thick</v-icon>
                                <v-icon v-else>mdi-arrow-bottom-left-bold-outline</v-icon>
                            </uv-button>
                            <v-menu>
                                <template v-slot:activator="{ on }">
                                    <uv-button small icon  v-on="on" title="More links">
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </uv-button>
                                </template>
                                <v-list dense>
                                    <v-list-item 
                                        v-for="goToButtonId of getXbrlIdsByConceptId(item.id).slice(3)"
                                        :key="`item-goto-${goToButtonId}`"
                                        @click="goToTag(goToButtonId)">
                                        <v-list-item-content>
                                            <v-list-item-icon>
                                                <uv-button small icon 
                                                :title="!isContinuationItem(goToButtonId)?'Go to tag':'Go to tag continuation'" 
                                                :color="currentSelectedContinuation(goToButtonId) && showEditAndDeleteButtons(item) ? 'warning' : 'blue'">
                                                    <v-icon v-if="!isContinuationItem(goToButtonId)">mdi-arrow-bottom-left-thick</v-icon>
                                                    <v-icon v-else>mdi-arrow-bottom-left-bold-outline</v-icon>
                                                </uv-button>
                                            </v-list-item-icon>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                        
                    </template>
                    <template #label="{item,attrs,on}">
                        <div
                            :id="`id-${item.id}`"
                            class="itemLabel"
                            v-bind="attrs"
                            v-on="on" 
                            @click.stop="selectedId = item.id">
                            {{item.label}}
                        </div>
                    </template>
                </v-treeview>
            </template>
            <v-overlay
                :absolute="true"
                :value="selectedConcept != null"
                color="white"
                opacity="1">
                <v-btn @click="closeDetailsMenu" icon outlined><v-icon color="black">mdi-arrow-left</v-icon></v-btn>
                <v-card flat color="white" style="max-height: 95%;overflow-y:auto">
                    <v-card-text>
                        <template v-for="(label,info) of selectedConcept">
                            <v-row dense :key="info" class="infoContainer" v-if="info!='references' && info!='displayRefs'">
                                <v-col style="flex-grow: 0.3;">
                                    <span class="blackText"><strong>{{capitalizeFirstLetter(info)}}</strong></span>
                                </v-col>
                                <v-col style="flex-grow: 0.7;">
                                    <span class="blackText">{{label}}</span>
                                </v-col>
                            </v-row>
                            <template v-else-if="info=='references'"></template>
                            <div class="infoContainer" style="overflow: unset;" :key="`${info}-ref`" v-else-if="info=='displayRefs' && Object.keys(label)?.length>0">
                                <v-row dense >
                                    <v-col style="flex-grow: 0.3;">
                                        <span class="blackText"><strong>References</strong></span>
                                    </v-col>
                                </v-row>
                                <template v-for="(details,ref) of label">
                                    <v-layout :key="ref" justify-space-between align-center @click="details.expanded=!details.expanded" style="cursor: pointer;">
                                        <span class="blackText ml-2" style="text-transform: none;">{{capitalizeFirstLetter(ref)}}</span>
                                        <v-icon color="black">
                                            <template v-if="!details.expanded">mdi-menu-down</template>
                                            <template v-else>mdi-menu-up</template>
                                        </v-icon>
                                    </v-layout>
                                    <v-expand-transition :key="ref">
                                        <div v-if="details.expanded">
                                            <v-row v-for="detail in details.details" :key="detail[0]" dense class="ml-4">
                                                <v-col style="flex-grow: 0.3;">
                                                    <span class="blackText"><strong>{{capitalizeFirstLetter(detail[0])}}</strong></span>
                                                </v-col>
                                                <v-col style="flex-grow: 0.7;">
                                                    
                                                    <span v-if="detail[0]!='URI'" class="blackText">{{detail[1]}}</span>
                                                    <a v-else :href="detail[1]" target="_blank">{{detail[1]}}</a>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </v-expand-transition>
                                </template>
                            </div>
                        </template>
                    </v-card-text>
                </v-card>
        </v-overlay>
            
        </div>
        <v-dialog
            :value="dialog"
            max-width="40%"
            max-height="50%"
            persistent>
                <validation-observer v-slot="{ handleSubmit }" slim>
                    <v-card>
                        <v-card-title>{{selectedItem.label}}</v-card-title>
                        <v-card-subtitle v-if="factData.continue">(Continuation)</v-card-subtitle>
                        <v-card-text>
                            <v-container fluid>
                                <v-row dense>
                                    <v-col cols="4">
                                        <uv-select
                                            :items="selectorItems.factTypes"
                                            v-model="factData.type"
                                            label="Fact Type"
                                            >
                    
                                        </uv-select>
                                    </v-col>
                                    <v-col cols="4" v-if="!factData.continue">
                                        <uv-select
                                            v-model="factData.period"
                                            label="Period"
                                            :items="reportInfo.periods"
                                            item-text="name"
                                            :placeholder="reportInfo.period.toLowerCase()"
                                            persistent-placeholder
                                            clearable
                                            :disabled="closestParentIsTableRow || isCellSelection">
                                        </uv-select>
                                    </v-col>
                                    <v-col cols="4" v-if="!factData.continue">
                                        <uv-select
                                            v-model="factData.periodType"
                                            label="Period Type"
                                            :items="selectorItems.periodType"
                                            :placeholder="reportInfo.period_type.toLowerCase()"
                                            persistent-placeholder
                                            clearable
                                            >
                                        </uv-select>
                                    </v-col>
                                    <v-col cols="4" v-if="!factData.continue && factData.type=='boolean'">
                                        <uv-select
                                            v-model="factData.transform"
                                            label="Fact Value"
                                            :items="[{text:'True', value:'fixed-true'},{text:'False', value:'fixed-false'}]"
                                            placeholder="Select fact value"
                                            rules="required"
                                            persistent-placeholder
                                            clearable
                                        >
                                        </uv-select>
                                    </v-col>
                                    <v-col cols="6" v-if="!factData.continue && factData.type=='date'">
                                        <uv-autocomplete
                                            v-model="factData.transform"
                                            label="Date format"
                                            :items="enumsItems.XbrlDateFormat"
                                            dense
                                            :menu-props="{maxWidth: '400'}"
                                            rules='required'
                                        >
                                            <template #item="{item}">
                                                <v-list-item-content>
                                                    <v-list-item-title>{{enums.XbrlDateFormat[item.value].label}}</v-list-item-title>
                                                    <v-list-item-subtitle class="no-clamp">{{enums.XbrlDateFormat[item.value].description}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </template>
                                        </uv-autocomplete>
                                    </v-col>
                                    <template  v-if="!factData.continue && factData.type=='enum'">
                                        <v-col cols="12">
                                            <uv-autocomplete
                                                v-model="factData.enum.selected"
                                                label="Fact Value"
                                                :items="factData.enum.values"
                                                placeholder="Select fact value"
                                                rules="required"
                                                item-text="label"
                                                persistent-placeholder
                                                chips deletable-chips small-chips
                                                return-object
                                                :multiple="factData.enum.multiple"
                                                clearable
                                            />
                                        </v-col>
                                        <v-col cols="12">
                                            <uv-switch-btn
                                            class="mt-0 mb-2"
                                            v-model="factData.enum.updateEditor"
                                            label="Update document"
                                            hint="If enabled, the selected fact value will be inserted in the document"
                                            persistent-hint
                                            >
                                            </uv-switch-btn>
                                        </v-col>
                                    </template>
                                </v-row>
                                <v-row v-if="!factData.continue && factDataIsNumeric">
                                    <v-col cols="4">
                                        <uv-text-field
                                            v-model="factData.decimals"
                                            label="Decimals"
                                            type="number"
                                            :placeholder="reportInfo.decimals.toString()"
                                            persistent-placeholder
                                            clearable>
                                        </uv-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <uv-text-field
                                            v-model="factData.numericScale"
                                            label="Numeric Scale"
                                            type="number"
                                            :placeholder="reportInfo.numeric_scale.toString()"
                                            persistent-placeholder
                                            clearable>
                                        </uv-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <uv-select
                                            v-model="factData.numericTransform"
                                            label="Numeric Transform"
                                            :items="selectorItems.numericTransform"
                                            :placeholder="reportInfo.numeric_transform.toLowerCase()"
                                            persistent-placeholder
                                            clearable>
                                        </uv-select>
                    
                                    </v-col>
                                </v-row>
                                <v-row v-if="!factData.continue && factDataIsNumeric">
                                    <v-col v-if="!usedUnit || usedUnit == 1">
                                        <uv-autocomplete
                                            v-model="factData.monetaryUnit"
                                            label="Monetary Unit"
                                            :items="monetaryUnits"
                                            item-value="id"
                                            item-text="name"
                                            :placeholder="reportInfo.monetary_units"
                                            persistent-placeholder
                                            clearable
                                            :filter="findUnit"
                                            :return-object="true"
                                            @change="(val) => onUnitChange(val, 'monetary')"
                                            :disabled="(usedUnit && usedUnit != 1) || factData.type != 'monetary'">
                    
                                            <template #item="{item}">
                                                <v-list-item-content>
                                                    <v-list-item-title>{{item.id}}</v-list-item-title>
                                                    <v-list-item-subtitle>{{item.name}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <uv-button color="info" icon :title="item.description" @click.stop="()=>false">
                                                        <v-icon>mdi-information-variant</v-icon>
                                                    </uv-button>
                                                </v-list-item-action>
                                            </template>
                                            <template #selection="{item}">
                                                {{item.id}}
                                            </template>
                                        </uv-autocomplete>
                                    </v-col>
                                    <v-col v-if="!usedUnit || usedUnit == 2">
                                        <uv-autocomplete
                                            v-model="factData.unit"
                                            label="Unit"
                                            :items="unitsItems"
                                            item-value="id"
                                            item-text="name"
                                            eager
                                            clearable
                                            :filter="findUnit"
                                            :return-object="true"
                                            @change="(val) => onUnitChange(val, 'unit')"
                                            :disabled="(usedUnit && usedUnit != 2) || factData.type != 'num'">
                    
                                            <template #item="{item}">
                                                <v-list-item-content>
                                                    <v-list-item-title>{{item.id}}</v-list-item-title>
                                                    <v-list-item-subtitle>{{item.name}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <uv-button color="info" icon :title="item.description" @click.stop="()=>false">
                                                        <v-icon>mdi-information-variant</v-icon>
                                                    </uv-button>
                                                </v-list-item-action>
                                            </template>
                                            <template #selection="{item}">
                                                {{item.id}}
                                            </template>
                                        </uv-autocomplete>
                                    </v-col>
                                    <v-col v-if="!usedUnit || usedUnit == 3">
                                        <uv-autocomplete
                                            class="complex-unit-selector"
                                            v-model="factData.complexUnit"
                                            label="Complex Unit"
                                            :items="reportInfo.complex_units"
                                            item-value="name"
                                            item-text="name"
                                            eager
                                            clearable
                                            :filter="findUnit"
                                            @change="(val) => onUnitChange(val, 'complex')"
                                            :disabled="(usedUnit && usedUnit != 3) || factData.type != 'num'">
                    
                                            <template #item="{item}">
                                                <v-list-item-content>
                                                    <v-list-item-title>{{item.name}}</v-list-item-title>
                                                    <v-list-item-subtitle>{{item.numerator}} per {{item.denominator}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </template>
                                            <template #append>
                                                <uv-button small color="info" icon title="Add Complex Unit" @click.stop="displayAddComplexUnitDialog = true" :disabled="(usedUnit && usedUnit != 3) || factData.type != 'num'">
                                                        <v-icon>mdi-plus-thick</v-icon>
                                                </uv-button>
                                            </template>
                                        </uv-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row v-if="!factData.continue && factDataIsNumeric">
                                    <v-col cols="6">
                                        <v-switch
                                            class="sign-switch"
                                            v-model="factData.reverseSign"
                                            label="Reverse fact value sign">
                                        </v-switch>
                                    </v-col>
                                </v-row>
                                <v-card v-if="!factData.continue" outlined tag="fieldset" elevation=1>
                                    <legend>
                                        <v-layout>
                                            <label class="pa-2 v-label font-weight-medium info--text">Dimensions</label>
                                            <v-spacer></v-spacer>
                                            <uv-button icon color="success" title="Add dimension" @click="addDimension">
                                                <v-icon>mdi-plus</v-icon>
                                            </uv-button>
                                        </v-layout>
                                    </legend>
                    
                                    <template v-for="(dimension, idx) of factData.dimensions">
                                        <v-divider v-if="idx > 0" :key="`div-${idx}`"></v-divider>
                                        <v-row class="px-1" dense  :key="`dim-${idx}`">
                                            <v-col cols="12">
                                                <v-autocomplete
                                                    label="Dimension Name"
                                                    v-model="dimension.dimensionTagName"
                                                    @change="dimension.dimensionTagValue = ''"
                                                    :items="dimensionNameItems"
                                                    item-text="text"
                                                    clearable>
                                                    <template #append-outer>
                                                        <uv-button icon color="error" title="Remove dimension" @click="removeDimension(idx)">
                                                            <v-icon>mdi-minus</v-icon>
                                                        </uv-button>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col v-if="dimension.dimensionTagName != '' && dimension.dimensionTagName != null && dimension.dimensionTagName != 'total'">
                                                <v-autocomplete
                                                label="Dimension Value"
                                                v-model="dimension.dimensionTagValue"
                                                :items="dimensionsDict[dimension.dimensionTagName]"
                                                clearable>
                                                    <template #append-outer>
                                                        <span style="width:36px"></span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-card>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                                <v-btn
                                    color="grey darken-1"
                                    text
                                    @click="closeDialog">
                                Discard
                                </v-btn>
                                <v-btn
                                    color="green darken-1"
                                    text
                                    @click="handleSubmit(applyTag)">
                                    Apply
                                </v-btn>
                        </v-card-actions>
                    </v-card>
                </validation-observer>
        </v-dialog>
        <slot></slot>

        <uv-confirm-dialog ref="newNamespaceConfirmDialog">
            <span class="font-weight-bold">{{newNamespaceConfirmDialogText}}</span>
        </uv-confirm-dialog>
        
        <v-dialog :value="displayNamespaceDialog" max-width="500px">
            <add-namspace-form ref="form" 
                :newUri="newNamespaceUri" 
                @close="displayNamespaceDialog = false; clearMonetaryUnit()"
                @done="displayNamespaceDialog = false; clearMonetaryUnit()">
            </add-namspace-form>
        </v-dialog>
        <v-dialog :value="displayAddComplexUnitDialog"
            persistent
            width="50%">
                 <complex-unit-form :report="reportInfo" @ok="addNewComplexUnit" @cancel="displayAddComplexUnitDialog = false"></complex-unit-form>
        </v-dialog>
    </v-container>
    
</template>

<script>
import { TextSelection } from 'prosemirror-state';
import { mapGetters, mapState, mapMutations } from 'vuex';
import { pickBy } from "lodash/object";
import { default as UvConfirmDialog } from "./ConfirmDialog";
import ComplexUnitForm from "@/views/Reports/ComplexUnitForm";
import { findParentNodeClosestToPos } from '@tiptap/core';
import { NodeSelection } from 'prosemirror-state';
import AddNamspaceForm from './AddNamspaceForm.vue';
import { dimensionsMixin, enumsMixin } from "@/plugins/mixins"
import { debounce, cloneDeep } from 'lodash';
let initialData = {
    reverseSign: false,
    period: "",
    periodType: "",
    decimals: null,
    numericScale: null,
    monetaryUnit: null,
    unit: null,
    complexUnit: null,
    numericTransform: "",
    type: "",
    escape: false,
    dimensions: [],
    transform: null,
    enum: {
        values: [],
        selected: null,
        multiple: false,
        updateEditor: true
    },
    continue: false,
};
export default {
    name: "TaxonomiesMenu",
    mixins: [dimensionsMixin, enumsMixin],
    components: {
        UvConfirmDialog,
        "complex-unit-form" : ComplexUnitForm,
        "add-namspace-form" : AddNamspaceForm,
    },
    props:{
        isReadOnly: {
            type: Boolean,
            default: true
        },
        filterOnlyAppliedTags: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            enumNames: ["XbrlDateFormat"],
            selectedId: null,
            search: "",
            filteredElements: [],
            displayDetailsMenu: false,
            openNodes: [],
            dialog: false,
            usedUnit: null,
            selectorItems: {
                periodType: ['instant','instant-start','duration'],
                numericTransform: ['num-dot-decimal','num-comma-decimal','num-unit-decimal'],
                factTypes: [
                    { header: "Inline tags" },
                    { text: "Text", value: "string" },
                    { text: "Numeric", value: "num" },
                    { text: "Monetary", value: "monetary" },
                    { text: "Boolean", value: "boolean" },
                    { text: "Enumeration", value: "enum" },
                    { text: "Date", value: "date" },
                    { divider: true },
                    { header: "Block tags" },
                    { text: "TextBlock", value: "block" }
                ]
            },
            factData: cloneDeep(initialData),
            selectedItem: {},
            editMode: false,
            selectedMark: '',
            selectedBlock: '',
            newNamespaceConfirmDialogText: "Namespace of unit is not saved in the report. \nDo you wish to add it ?",
            displayNamespaceDialog: false,
            newNamespaceUri: "",
            newNamespaceName: "",
            isAddingNewNamespace: false,
            displayAddComplexUnitDialog: false,
            searchText: "",
            setSearchText: debounce(()=>{
                this.searchText = this.search
            }, 500),
        }
    },
    created() {
        this.highlightedItems = [];
    },
    computed: {
        ...mapState("xbrlData" ,[
            "taxonomies",
            "editorSelection",
            "selectionAttributes",
            "reportTags",
            "reportInfo"
        ]),
        ...mapGetters("xbrlData", {
            getConceptData: "getConceptDataByXbrlId",
            getTagById: "getTagById",
            getXbrlIdsByConceptId: "getXbrlIdsByConceptId",
            monetaryUnits: "getReportMonetaryUnits"
        }),
        isTextSelection: function() {
            if(this.editorSelection instanceof TextSelection) {
                return true;
            } else {
                return false;
            }
        },
        isCellSelection: function() {
            let result = false;
            if (this.editorSelection && this.editorSelection instanceof NodeSelection) {
                if(this.editorSelection?.node?.type?.name === "tableRow") {
                        result = true;
                }
            };
            return result;
        },
        factDataIsNumeric: function() {
            return ["num", "monetary"].includes(this.factData.type);
        },
        factDataIsEnumMultiple() {
            return this.factData.enum?.multiple === true;
        },
        isEmptySelection:  function() {
            return this.editorSelection?.empty;
        },
        closestParentIsTableRow: function() {
            if (this.isEmptySelection) return false
            let parentNode = findParentNodeClosestToPos(this.editorSelection.$from, (node) => {
                if(node.type.name === "tableRow") {
                    return true;
                }
            });
            if(parentNode) {
                return true;
            } else {
                return false;
            }
        },
        highlightedItems: {
            get() {
                let highlightedItems = [];
                for (let tag of Object.values(this.reportTags)) {
                    if(tag?.type != "table") {
                        highlightedItems.push(tag.id);
                    } else {
                        if(tag?.rows) {
                            for(let row of Object.values(tag.rows)) {
                                highlightedItems.push(row.map(c=>c.id));
                            }
                        }
                    }
                }
                return highlightedItems;
            },
            set() { }
        },
        unitsItems: function(){
            let units = [];
            const storeUnits = this.$store.state.xbrlData.units;
            for (const header of Object.keys(storeUnits)){
                units.push({header: header.replace(header[0], header[0].toUpperCase())})
                units = units.concat(storeUnits[header]);
                units.push({divider: true});
            }

            return units;
        },
        selectedConcept(){
            if (!this.selectedId) return null
            let concept = this.getConceptData(this.selectedId)
            if (!concept) return null
            let references = concept.references
            this.$set(concept, 'displayRefs', {})
            if (references){
                for (let ref in references){
                    let refs = []
                    let values = references[ref]
                    for (let [name, val] of values){
                        refs.push([name, val])
                        if (name=="URI") break
                    }
                    this.$set(concept.displayRefs, ref, {'details': refs, expanded: false})
                }
                
            }
            return concept
        },
        appliedTags(){
            if (this.selectionAttributes.row && this.selectionAttributes.table){
                const tableId = this.selectionAttributes.table
                const rowId = this.selectionAttributes.row
                return (this.reportTags[tableId]?.rows[rowId] || []).map(c => c.id)
            }else{
                return [
                    ...(this.selectionAttributes?.marks || []),
                    ...(this.selectionAttributes?.textBlock || [])
                ].map(c => this.reportTags[c]?.id)
            }
        }
    },
    watch: {
        selectionAttributes: {
            immediate: true,
             handler: function() {
                if (this.taxonomies.pre) {
                    if (this.highlightedItems.length > 0 ){
                        if(this.selectionAttributes.marks?.length > 0) {
                            for(let mark of this.selectionAttributes.marks) {
                                let tag = this.reportTags[mark];
                                if(tag != null || tag != undefined) {
                                    this.openHighlightedNode(tag);
                                    if (this.selectionAttributes.goToTagId){
                                        if (mark === this.selectionAttributes.goToTagId){
                                            this.$nextTick(() => {
                                                try {
                                                    this.$vuetify.goTo(`#id-${tag.id}`, { container: ".tree-view-container" });
                                                } catch(err) {
                                                    //do nothing, most probably the tag destination is filtered out in the tree view
                                                }
                                            })
                                        }
                                        
                                    }
                                    else{
                                        this.$nextTick(() => {
                                            try {
                                                this.$vuetify.goTo(`#id-${tag.id}`, { container: ".tree-view-container"});
                                            } catch(err) {
                                                //do nothing, most probably the tag destination is filtered out in the tree view
                                            }
                                        })
                                    }
                                }
                            }
                        }
                        if(this.selectionAttributes.row && this.selectionAttributes.table) {
                            let tag = this.reportTags[this.selectionAttributes.table].rows[this.selectionAttributes.row];
                            if(tag != null && tag != undefined) {
                                this.openHighlightedNode(tag);
                                this.$nextTick(() => {
                                    try {
                                        this.$vuetify.goTo(`#id-${tag[0].id}`, { container: ".tree-view-container"});
                                    }catch(err){
                                        //do nothing, most probably the tag destination is filtered out in the tree view
                                    }
                                })
                            }
                        }
                        if(this.selectionAttributes.textBlock?.length > 0){
                            for (let textBlock of this.selectionAttributes.textBlock){
                                let tag = this.reportTags[textBlock];
                                if(tag != null || tag != undefined) {
                                    this.openHighlightedNode(tag);
                                    if (this.selectionAttributes.goToTagId){
                                        if (textBlock === this.selectionAttributes.goToTagId){
                                            this.$nextTick(() => {
                                                try {
                                                    this.$vuetify.goTo(`#id-${tag.id}`, { container: ".tree-view-container"});
                                                } catch(err) {
                                                    //do nothing, most probably the tag destination is filtered out in the tree view
                                                }
                                            })
                                        }
                                        
                                    }
                                    else{
                                        this.$nextTick(() => {
                                            try {
                                                this.$vuetify.goTo(`#id-${tag.id}`, { container: ".tree-view-container"});
                                            } catch (err) {
                                                //do nothing, most probably the tag destination is filtered out in the tree view
                                            }
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
            },
            deep: true
        },
        selectedId: function(newVal, oldVal) {
            if (oldVal){
                let concept = this.getConceptData(oldVal)
                if (concept){
                    concept.displayRefs = {}
                }
            }
        },
        'factData.type': function(newVal, oldVal){
            this.factData.escape = (newVal === 'block')
            if (newVal == 'date'){
                if (!this.factData.transform) {
                    this.factData.transform = this.reportInfo.date_format
                }

                if (!this.factData.periodType){
                    this.factData.periodType = "instant"
                }
            } else {
                this.factData.transform = null
                if (oldVal == 'date'){
                    this.factData.periodType = ""
                }
            }

            if (newVal !== 'enum'){
                this.factData.enum.selected = null
                this.factData.enum.values = []
                this.factData.enum.multiple = false
            }
            this.resetUnits()
        },
        filterOnlyAppliedTags: function(newVal){
            if (newVal){
                this.searchText = " "
            }else{
                this.searchText = this.search
            }
        },
        search: function(){
            this.setSearchText();
        },
        searchText: function(){
            this.$refs.treeView.updateAll(true);
        }
    },
    methods: {
        ...mapMutations(["setGlobalMessage"]),
        ...mapMutations("xbrlData",["setReportBaseInfo"]),
        closeDetailsMenu() {
            this.selectedId = null;
        },
        filterTaxonomies(item){
            let concept = this.taxonomies.concepts[item.id];
            let searchText = this.searchText.toLowerCase()
            if(concept && (concept.name.toLowerCase().includes(searchText) || concept.label.toLowerCase().includes(searchText) || concept.xId.toLowerCase().includes(searchText))){
                if (this.filterOnlyAppliedTags){
                    return this.appliedTags?.includes(item.id)
                }
                return true
            }
            return false
        },
        getNodeById(id, node){
            if (node){
                if (node.id === id){
                    return node;
                }else{
                    if ( node.concepts && node.concepts.length > 0) {
                        for (let child of node.concepts){
                            let found = this.getNodeById(id, child);
                            if (found){
                                return found;
                            }
                        }
                    }
                }
            }
            return false;
        },
        closeSideMenu() {
            this.$store.dispatch('xbrlData/closeSideMenu');
        },
        handleClickOnRemoveTagBtn(item) {
            if(this.selectionAttributes.marks && this.selectionAttributes.marks.length > 0) {
                for(let mark of this.selectionAttributes.marks) {
                    let tag = this.reportTags[mark];
                    if((tag != null || tag != undefined) && (tag.id === item.id)) {
                        this.$emit("onRemoveTag",mark);
                    }
                }
            } else if(this.selectionAttributes.row) {
                let row = this.reportTags[this.selectionAttributes.table].rows[this.selectionAttributes.row];
                let tag = row.find(c=> c.id === item.id)
                if((tag != null || tag != undefined) && (tag.id === item.id)) {
                    this.$emit("onRemoveTag",tag.id);
                }
            } else if(this.selectionAttributes.textBlock?.length) {
                for (let textBlock of this.selectionAttributes.textBlock){
                    let tag = this.getTagById(textBlock);
                    if((tag != null || tag != undefined) && (tag.id === item.id)) {
                        this.$emit("onRemoveTag",textBlock);
                    }
                }
            }
        },
        closeDialog() {
            this.dialog = false;
            this.resetDialogFields();
            this.editMode = false;
            this.selectedMark = '';
        },
        openDialog(item, continuation=false) {
            this.selectedItem = item;
            this.dialog = true;
            this.factData.continue = continuation
            this.factData.type = "num"
            let concept = this.getConceptData(item.id)
            let conceptType = concept?.type.split(":")[1]
            switch (conceptType){
                case "monetaryItemType":
                    this.factData.type = "monetary"
                    break
                case "stringItemType":
                case "leiItemType":
                    this.factData.type = "string"
                    break
                case "textBlockItemType":
                    this.factData.type = "block"
                    break
                case "booleanItemType":
                    this.factData.type = "boolean"
                    break
                case "enumerationItemType":
                case "enumerationSetItemType":
                    this.factData.type = "enum"
                    this.factData.enum.values = this.taxonomies.enums[concept.enumDomain] || []
                    this.factData.enum.multiple = (conceptType == "enumerationSetItemType")
                    break
                case "dateItemType":
                    this.factData.type = "date"
                    this.factData.transform = this.reportInfo.date_format
                    this.factData.periodType = "instant"
                    break
            }

            if ( this.selectionAttributes.marks && this.selectionAttributes.marks.length > 0) {
                for(let mark of this.selectionAttributes.marks) {
                    let tag = this.reportTags[mark];
                    if((tag != null || tag != undefined) && tag.id === item.id) {
                        this.setSelectorsData(tag);
                        this.editMode = true;
                        this.selectedMark = mark;
                        this.checkUsedUnitType(tag);
                    }
                }
            } else if (this.selectionAttributes.textBlock) {
                for (const textBlock of this.selectionAttributes.textBlock){
                    let tag = this.reportTags[textBlock];
                    if(tag != null && tag != undefined && tag.id === item.id) {
                        this.setSelectorsData(tag);
                        this.editMode = true;
                        this.selectedBlock = this.selectionAttributes.textBlock;
                        this.checkUsedUnitType(tag);
                    }
                }
            } else {
                if (this.selectionAttributes.row && this.selectionAttributes.table) {
                    let tag = this.reportTags[this.selectionAttributes.table].rows[this.selectionAttributes.row][0];
                    let existingTag = this.reportTags[this.selectionAttributes.table].rows[this.selectionAttributes.row].find(c=> c.id === item.id)
                    if(tag != null && tag != undefined) {
                        this.setSelectorsData(tag);
                        if (existingTag){
                            this.editMode = true;
                        }
                        this.checkUsedUnitType(tag);
                    }
                }
            }
        },
        resetDialogFields() {
            this.factData = cloneDeep(initialData);
            this.usedUnit = null
        },
        resetUnits(){
            this.usedUnit = null
            this.factData.monetaryUnit = null
            this.factData.unit = null
            this.factData.complexUnit = null
        },
        applyTag() {
            this.$emit('onApplyTag', this.selectedItem.id, this.factData, this.editMode, this.selectedMark, this.selectedBlock);
            this.closeDialog();
        },
        openHighlightedNode(tag) {
            let concepts = tag
            if (!Array.isArray(tag)){
                concepts = [tag]
            }
            for(let item of this.taxonomies.pre) {
                let childrens = this.getAllChildrenNodes(item);
                childrens.forEach(elem => {
                    concepts.forEach(concept=>{
                        if(elem.id === concept.id) {
                            this.openNodes.push(...childrens.map(child => child.id));
                        }
                    })
                });
            }
        },
        setSelectorsData(tag) {
            this.factData.reverseSign = tag.attrs.reverseSign;
            this.factData.period = tag.attrs.period;
            this.factData.periodType = tag.attrs.periodType;
            this.factData.decimals = tag.attrs.decimals;
            this.factData.numericScale = tag.attrs.numericScale;
            this.factData.monetaryUnit = tag.attrs.monetaryUnit;
            this.factData.unit = tag.attrs.unit;
            this.factData.complexUnit = tag.attrs.complexUnit;
            this.factData.numericTransform = tag.attrs.numericTransform;
            this.factData.transform = tag.attrs.transform ?? null;
            this.factData.type = tag.attrs.type;
            this.factData.continue = tag.attrs.continue;
            this.factData.dimensions = tag.attrs.dimensions ?? [];
            if (this.factData.enum?.multiple) { 
                const values = tag.attrs.enumValue.split(" ") || []
                this.factData.enum.selected = this.factData.enum.values.filter(v => values.includes(v.value))
            } else {
                this.factData.enum.selected = tag.attrs.enumValue ?? null
            }
        },
        addDimension(){
            this.factData.dimensions.push({
                dimensionTagName: "",
                dimensionTagValue: "",
            })
        },
        removeDimension(idx){
            this.factData.dimensions.splice(idx, 1)
        },  
        findUnit(item, queryText) {
            const searchText = queryText.toLowerCase();
            return item.name?.toLowerCase().indexOf(searchText) > -1 || item.id?.toString().toLowerCase().indexOf(searchText) > -1;
        },
        showContinueButton(item){
            let reportTag = pickBy(this.reportTags, (tag,)=> tag.id == item.id)
            return Object.keys(reportTag).length > 0
        },
        conceptIsAbstract(item){
            const concept = this.taxonomies.concepts[item.id]
            return !concept || concept.abstract == 'true';
        },
        showEditAndDeleteButtons(item) {
            if (this.isEmptySelection){
                let mark = this.selectionAttributes.marks?.map(mark => this.reportTags[mark]).find(tag => tag.id === item.id);
                let row = this.reportTags[this.selectionAttributes.table]?.rows[this.selectionAttributes.row];
                let textBlock = this.selectionAttributes.textBlock?.map(block => this.reportTags[block]).find(tag => tag.id === item.id);
                if (mark) {
                    return true;
                }

                if (row?.some(r=> r.id === item.id)){
                    return true;
                }

                if (textBlock) {
                    return true;
                }
            }
            return false;
        },
        goToTag(id){
            this.$emit('onGoToTag', id);
        },
        onUnitChange(val, type){
            this.usedUnit = null
            if (!val){
                return
            }
            switch (type){
                case 'monetary':
                    this.usedUnit = val ? 1 : null
                    break
                case 'unit': {
                    if (val.ns != "http://www.xbrl.org/2003/instance"){
                        let ns = this.reportInfo.namespaces.filter((n)=> n.url == val.ns)
                        if (!ns?.length){
                            this.setGlobalMessage({
                                    message: `Namespace ${val.ns} is not defined in report info`,
                                    severity: "warning"
                                })
                            this.$refs.newNamespaceConfirmDialog.open().then(confirm => {
                                if (confirm) {
                                    this.newNamespaceUri = val.ns;
                                    this.displayNamespaceDialog = true;
                                } else {
                                    this.clearMonetaryUnit();
                                }
                            });
                        }
                    }
                        this.usedUnit = val ? 2 : null
                        break
                    }
                case 'complex': {
                    this.usedUnit = val ? 3 : null
                    break
                }
            }
        },
        clearMonetaryUnit() {
            this.factData.unit = null;
            this.usedUnit = null;
        },
        currentSelectedContinuation(itemId) {
            return (
                this.selectionAttributes.marks?.some(mark => mark == itemId) || 
                this.selectionAttributes.textBlock?.some(textBlock => textBlock === itemId) || 
                this.selectionAttributes.row === itemId
            );
        },
        addNewComplexUnit(unit) {
            let newReportInfo = Object.assign({}, this.reportInfo);
            newReportInfo.complex_units.push(unit);
            this.$apiHttp({
                method: "PUT",
                url: "/report",
                data: newReportInfo
                }).then((response) => {
                    this.setReportBaseInfo(response.data.data);
                }).finally(() => {
                    this.displayAddComplexUnitDialog = false;
                    this.factData.complexUnit = unit;
                    this.usedUnit = 3;
            });
            
        },
        checkUsedUnitType(tag) {
            if(tag.attrs?.unit) {
                this.usedUnit = 2;
            }
            if(tag.attrs?.complexUnit) {
                this.usedUnit = 3;
            }
            if(tag.attrs?.monetaryUnit) {
                this.usedUnit = 1
            }
        },
        capitalizeFirstLetter(str) {
            return str.charAt(0).toUpperCase() + str.slice(1)
        },
        isContinuationItem(item){
            const tag = this.reportTags[item]
            return tag?.attrs?.continue || false
        }
    }
}
</script>

<style lang="scss" scoped>
    :deep(.sign-switch) {
        .v-input__slot {
            flex-direction: row-reverse;
        }
    }
    :deep() {
        .v-treeview-node__root{
            min-height: unset;
            font-size: 15px;
            height: 25px;
        }
        .v-treeview-node__prepend {
            min-width: 0;
        }

    }

    .v-treeview-node {
        height: 20px;
    }
    .search {
        display: flex;
        justify-content: space-between;
    }
    .blackText {
        color: black;
        font-size: 15px;
    }
    :deep(){
        .v-overlay__content {
            flex-grow: 1;
        }

    }
    .v-overlay{
        align-content: stretch;
        align-items: stretch;
        justify-content: start;
    }

    .tree-view-container{
        overflow-y: auto;
    }

    .infoContainer {
        border-bottom: 1px solid lightgray;
        word-break: break-all;
        margin-bottom: -1px;
        overflow: auto;
    }

    .parent-container{
        overflow-x: auto;
        padding-top: 0;
        padding-left: 0;
        padding-right: 0;
    }
    .itemLabel {
        cursor: pointer;
    }
    :deep() {
        .complex-unit-selector {
            .v-input__append-inner {
                align-self: unset;
            }
        }

        .no-clamp {
            white-space: normal !important;
            overflow: visible !important;
            text-overflow: unset !important;
        }
    }
</style>